export { default as SkeletonBadge } from './SkeletonBadge';
export { default as SkeletonBox } from './SkeletonBox';
export { default as SkeletonLabel } from './SkeletonLabel';
export { default as SkeletonText } from './SkeletonText';
export { default as SkeletonTitle } from './SkeletonTitle';
